import CircularProgress from "@material-ui/core/CircularProgress";

export default function LoadingWrapper({ condition, children }) {
  return condition ? <>{children}</> : <CircularProgress />;
}
